module.exports = __webpack_public_path__ + "static/photo-2794cba565ba99be2663badf2bdd382c.png";